import { CardState } from '@witkac/kartamiejska-shared';

export default {
  title: 'card',
  type: 'object',
  properties: {
    state: {
      type: 'string',
      title: 'Status karty',
      fieldRequired: true
    },
    number: {
      type: 'string',
      title: 'Numer karty',
      fieldRequired: `this.state === "${CardState[CardState.READY]}" || this.state === "${
        CardState[CardState.ACTIVE]
      }"`,
      maxLength: 500
    },
    profileId: {
      type: 'number',
      title: 'Użytkownik karty',
      fieldRequired: true
    }
  }
};
